import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_8/0001.jpg'
import img2 from '../assets/issue_8/0002.jpg'
import img3 from '../assets/issue_8/0003.jpg'
import img4 from '../assets/issue_8/0004.jpg'
import img5 from '../assets/issue_8/0005.jpg'
import img6 from '../assets/issue_8/0006.jpg'
import img7 from '../assets/issue_8/0007.jpg'
import img8 from '../assets/issue_8/0008.jpg'
import img9 from '../assets/issue_8/0009.jpg'
import img10 from '../assets/issue_8/0010.jpg'
import img11 from '../assets/issue_8/0011.jpg'
import img12 from '../assets/issue_8/0012.jpg'
import img13 from '../assets/issue_8/0013.jpg'
import img14 from '../assets/issue_8/0014.jpg'
import img15 from '../assets/issue_8/0015.jpg'
import img16 from '../assets/issue_8/0016.jpg'
import img17 from '../assets/issue_8/0017.jpg'
import img18 from '../assets/issue_8/0018.jpg'
import img19 from '../assets/issue_8/0019.jpg'

export default class Mag008 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
      </div>
    )
  }
}
